// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-popup[data-v-29adaeb2]  .modal{padding:28px!important}.modal-result-popup[data-v-29adaeb2]{display:flex;flex-direction:column;align-items:center;justify-content:center}.modal-result-popup p[data-v-29adaeb2]{text-align:center}.modal-result-popup button[data-v-29adaeb2]{margin-top:20px}h1[data-v-29adaeb2]{font-family:\"Instrument Serif\",Georgia,Times New Roman,serif;font-style:normal;font-weight:400;font-size:28px;line-height:38px}", ""]);
// Exports
module.exports = exports;
